/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Carreras',
    titleMeta: 'Carreras — Ofertas de empleo | CamDiab',
    descriptionMeta: 'Explore oportunidades de carrera en CamDiab. Únase a nuestro equipo para mejorar la vida con diabetes.',
    keywords: 'CamDiab carreras, empleo, ofertas, diabetes',
    localeMeta: 'es_es',

    bannerTitle: 'Ofertas de empleo',
    bannerSubtitle: '¿Le interesa unirse a nuestro equipo?',
    heroNote: 'Todas las ofertas se publican en inglés.',

    introBody:
        'Si busca un nuevo reto y desea ayudar a impulsar un cambio significativo, nos encantaría saber de usted. Invertimos en nuestra gente, el corazón de CamDiab. Los beneficios para empleados están pensados para sacar lo mejor de cada uno, e incluyen:',

    benefitsTitle: '',
    benefits: [
        'Generosa aportación del empleador a la pensión',
        'Seguro médico privado',
        'Seguro de vida',
        'Bonus anual discrecional',
        '29 días de vacaciones anuales más 8 días festivos',
        'Oportunidad de trabajar en tecnología innovadora con potencial para transformar el manejo de la diabetes y mejorar resultados para los pacientes',
        'Entorno de trabajo colaborativo y dinámico',
        'Salario y paquete de beneficios competitivos, con oportunidades de desarrollo profesional y carrera',
    ],

    outroHtml:
        'Si le apasiona generar impacto en el mundo real, nos encantaría saber de usted:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'No hay vacantes',
    emptyVacancyBody:
        'Puede que no estemos contratando en este momento, pero CamDiab crece y siempre nos interesa conocer a personas apasionadas por mejorar la vida con diabetes. Vuelva a consultar esta página.',

    applyLabel: 'Solicitar ahora',
};
